import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Role, Roles } from '../enums/enums';
import { UserService } from '@planetact/services/user.service';
import { ROLE_KEY } from '../configToken';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class RoleAdminGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private authService: MsalService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (this.authService.instance.getAllAccounts().length > 0) {
      return this.userService.getUserRole().pipe(
        map((userRole) => {
          if (userRole.roleName !== Role.Admin) {
            this.router.navigate(['/unauthorized']);
            return false;
          }
          return true;
        })
      );
    } else {
      this.router.navigate(['/unauthorized']);
      return false;
    }
  }
}
